import React from "react";
import GridHeader from "./GridHeader";
import GridBody from "./GridBody";
import { VisualOverlay } from "../Overlays";
import "./Grid.css";

/**
 * Grid
 * The scrollable wrapper around the table — the freeze-pane sticky
 * positioning all hangs off this element via the wrapperRef.  Renders
 * the column header, the body, and the absolute-positioned visual
 * overlay (images + charts) on top.
 */
const Grid = React.forwardRef(function Grid({
  wrapperRef, theadRef, tableRef,
  zoomScale, maxCols, colWidths, hiddenCols, hiddenRows,
  frozenCols, frozenColOffsets,
  selectionType, normalizedSelection,
  filters, activeFilterCol, normalizedRows,
  onToggleFilter, onApplyFilter, onCloseFilter,
  onSelectColumn, onHeaderContextMenu, onStartResize,
  isLastVisibleBeforeHidden, isLastVisibleBeforeHiddenRow,
  // Body props
  rowHeights, cellStyles, cellRichHtml, cellMerges, cellLinks,
  isRowVisible, selectedCell,
  frozenRows, measuredTheadHeight, frozenRowOffsets,
  onSelectRow, onStartSelection, onExtendSelection,
  onLinkClick, onCellContextMenu,
  // Overlay
  activeSheet, sheetImages, sheetCharts,
}, _ref) {
  return (
    <div className="simple-excel-grid-wrapper" ref={wrapperRef}>
      <table className="simple-excel-grid" style={{ zoom: zoomScale }} ref={tableRef}>
        <GridHeader
          ref={theadRef}
          maxCols={maxCols}
          colWidths={colWidths}
          hiddenCols={hiddenCols}
          frozenCols={frozenCols}
          frozenColOffsets={frozenColOffsets}
          selectionType={selectionType}
          normalizedSelection={normalizedSelection}
          isLastVisibleBeforeHidden={isLastVisibleBeforeHidden}
          filters={filters}
          activeFilterCol={activeFilterCol}
          normalizedRows={normalizedRows}
          onToggleFilter={onToggleFilter}
          onApplyFilter={onApplyFilter}
          onCloseFilter={onCloseFilter}
          onSelectColumn={onSelectColumn}
          onHeaderContextMenu={onHeaderContextMenu}
          onStartResize={onStartResize}
        />
        <GridBody
          normalizedRows={normalizedRows}
          rowHeights={rowHeights}
          colWidths={colWidths}
          cellStyles={cellStyles}
          cellRichHtml={cellRichHtml}
          cellMerges={cellMerges}
          cellLinks={cellLinks}
          hiddenCols={hiddenCols}
          hiddenRows={hiddenRows}
          isRowVisible={isRowVisible}
          isLastVisibleBeforeHidden={isLastVisibleBeforeHidden}
          isLastVisibleBeforeHiddenRow={isLastVisibleBeforeHiddenRow}
          selectedCell={selectedCell}
          normalizedSelection={normalizedSelection}
          selectionType={selectionType}
          frozenRows={frozenRows}
          frozenCols={frozenCols}
          measuredTheadHeight={measuredTheadHeight}
          frozenRowOffsets={frozenRowOffsets}
          frozenColOffsets={frozenColOffsets}
          onSelectRow={onSelectRow}
          onHeaderContextMenu={onHeaderContextMenu}
          onStartResize={onStartResize}
          onStartSelection={onStartSelection}
          onExtendSelection={onExtendSelection}
          onLinkClick={onLinkClick}
          onCellContextMenu={onCellContextMenu}
        />
      </table>

      <VisualOverlay
        activeSheet={activeSheet}
        sheetImages={sheetImages}
        sheetCharts={sheetCharts}
        colWidths={colWidths}
        rowHeights={rowHeights}
        zoomScale={zoomScale}
        hiddenCols={hiddenCols}
        hiddenRows={hiddenRows}
      />
    </div>
  );
});

export default Grid;
